import { Component, OnInit, SimpleChanges } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';

@Component({
  selector: 'app-custom-disclaimer',
  templateUrl: './custom-disclaimer.component.html',
  styleUrls: ['./custom-disclaimer.component.css']
})
export class CustomDisclaimerComponent implements OnInit  {
  public updatedvalue;
  public message;
  public reloadSubscription;
  public updatedCampaigns;
  public updatedAdvertisers;
  public showDisclaimer: boolean;
  public updatedCampaignLoadedSubscription;

  constructor(protected analyticsDataModel: AnalyticsDataModel
    ) { 
    EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).subscribe((response: any) => {
      this.checkUpdatedCampaigns()
    });

    EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).subscribe((response: any) => {
      this.initiaLoadCamapigns();
    });

    EmitterService.get(EVENT_EMITTERS.REFRESH_CAMPAIGNS).subscribe((response: any) => {
      this.initiaLoadCamapigns();
    });
  }

  ngOnInit(): void {
    this.showDisclaimer = false;
    this.message = this.analyticsDataModel.config.disclaimer;
    this.updatedCampaigns = this.analyticsDataModel.campaignsListForDropDown;
    this.updatedAdvertisers = this.analyticsDataModel.selectedAdvertisersListForDropDown;
    this.checkUpdatedCampaigns(); 

  }

  checkUpdatedCampaigns(){
    this.updatedCampaigns = this.analyticsDataModel.selectedCampaigns;
    this.showDisclaimerNote()
  }

  initiaLoadCamapigns() {
    this.updatedCampaigns = this.analyticsDataModel.campaignsListForDropDown.filter((item) => {
      if(this.analyticsDataModel.selectedCampaigns.find(campaign => campaign.id == item.id)) {
        return item;
      }
    })
    this.showDisclaimerNote();
  }

  showDisclaimerNote() {
    this.showDisclaimer = false;
    this.updatedAdvertisers = this.analyticsDataModel.selectedAdvertisers;
    if (this.updatedCampaigns.length > 0 && this.updatedAdvertisers.length > 0) {
      this.updatedCampaigns.forEach((campaign) =>{
        if (campaign.permission.includes('has_email_access') && campaign.active) {
          this.showDisclaimer = true;
        }
      })
    }
  }

}
